import React, { useContext, useState } from 'react';
import { Container, Typography } from '@mui/material';

import Loading from '../../components/Loading';
import { RemoteControlContext } from '../../ContextProvider';
import AlertDrawer from '../../components/AlertDrawer';
import { sortEventsByDate } from '../../helpers/sortEventsByDate';
import { Section } from '../../components/Section';

export default function MyList () {
    const [showDrawerAlert, setShowDrawerAlert] = useState(false);
    const { liveEvents, nowPlaying, handleEventSubClick, isLoading } = useContext(RemoteControlContext);

    const subscribedEvents = liveEvents.filter(event => event.subscribed && event.status !== 'LIVE');

    const showOverlapDrawer = (e, drawerMessage) => {
        e.stopPropagation();
        setShowDrawerAlert(drawerMessage);
    };

    const sortedEvents = sortEventsByDate(subscribedEvents);

    return (
        <Container variant='events'>
            <AlertDrawer drawerAlert={showDrawerAlert} closeDrawer={() => setShowDrawerAlert(false)} title='Overlapping Events' />
            {isLoading && <Loading />}

            <Section
              title='On Screen Now'
              events={nowPlaying}
              handleEventSubClick={handleEventSubClick}
              liveNowEvent
            />

            {sortedEvents.map(({ title, events }) =>
                <div key={title}>
                    <Section
                      events={events} title={title} titleVariant='date-title' futureEvent
                      otherEvents={subscribedEvents}
                      handleEventSubClick={handleEventSubClick}
                      handleOverlapIconClick={showOverlapDrawer}
                    />
                </div>
            )}

            {(!sortedEvents.length) &&
                <Typography variant='p'>
                    Once you subscribe to an event you will see it here.
                </Typography>}
        </Container>
    );
}
